/* Ordering data stays available before the optional customisation modal is loaded. */
(() => {
  if (window.PTCustomisation) return;
  function data() {
    const source = document.querySelector('[id^="pt-customisation-data-"]');
    try { return source ? JSON.parse(source.textContent) : null; } catch (_) { return null; }
  }
  window.PTCustomisation = {
    getProductInfo() {
      const product = data()?.product;
      return product ? {available: !!product.available, variantId: product.variantId, priceCents: product.priceCents, priceFormatted: product.priceFormatted} : {available: false};
    },
    isGenderReady(gender) { return !!data()?.genders?.[gender]; },
    generateId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      const random = Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10);
      return 'ptc-' + Date.now().toString(36) + '-' + random;
    },
    // User taps are intercepted before builder handlers; the real synchronous
    // open API is installed before their click is replayed.
    open() { return false; },
    deferred: true
  };
})();
